import DomainIcon from '@mui/icons-material/Domain';
import GroupsIcon from '@mui/icons-material/Groups';
import LinkIcon from '@mui/icons-material/Link';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PublicIcon from '@mui/icons-material/Public';
import VisibilityIcon from '@mui/icons-material/Visibility';
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import { Grid, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { IWorkspace } from 'wisestep-api';
import {
  WsButton,
  WsChip,
  WsChipVariants,
  WsDetailsCard,
  WsIconJobOutline,
  WsIconMapping,
  WsIconSubmitted,
  WsIconSuggestions,
  WsIconPersons,
  WsTypoColors,
  timeSince,
} from 'wisestep-base';

import JobCountCard from '../../../jobs/listing/components/jobsCountCard/JobsCountCard';

interface WorkspaceDetailsCardProps {
  workspaceId?: string;
  title: string;
  planType?: string;
  visibility?: string;
  ownerId?: string;
  status?: string;
  ownerName?: string;
  dateCreated?: Date;
  workspace: IWorkspace;
}

const WorkspaceDetailsCard = ({
  workspaceId,
  title,
  planType,
  visibility,
  ownerId,
  status,
  ownerName,
  dateCreated,
  workspace,
}: WorkspaceDetailsCardProps) => {
  const navigate = useNavigate();
  return (
    <Grid
      item
      xs={12}
      justifyContent="flex-end"
      justifyItems="flex-end"
      alignContent="flex-end"
      pt={2}
    >
      <WsDetailsCard
        title={title}
        detailsArray={[
          {
            icon: <PublicIcon color="secondary" fontSize="small" />,
            labelName: `${ownerName}`,
            popOverText: 'Geography',
          },
          {
            icon: <DomainIcon color="secondary" fontSize="small" />,
            labelName: `OwnerName ${ownerName}`,
            popOverText: 'OwnerName',
          },
          {
            icon: <MailOutlineIcon color="secondary" fontSize="small" />,
            labelName: `Owner: ${ownerId}`,
            popOverText: 'Email',
          },
          {
            icon: <LinkIcon color="secondary" fontSize="small" />,
            labelName: 'Link',
            popOverText: 'Link',
          },
          {
            icon: <WsIconJobOutline />,
            labelName: `${planType}`,
            popOverText: 'Plan Type',
          },
          {
            icon: <VisibilityIcon color="secondary" fontSize="small" />,
            labelName: `${visibility}`,
            popOverText: 'Visibility',
          },
          {
            icon: <GroupsIcon color="secondary" fontSize="small" />,
            labelName: `${workspace.id}`,
            popOverText: 'Max Users',
          },
          {
            icon: <WatchLaterIcon color="secondary" fontSize="small" />,
            labelName: `${dateCreated ? timeSince(dateCreated.toString()) : ''}`,
            popOverText: `Created On: ${dateCreated ? dateCreated.toString() : ''}`,
          },
        ]}
        gridXs={4}
        isActiveCard={status === 'ACTIVE'}
        rightChildren={<WsChip value="More.." variant={WsChipVariants.PRIMARY} />}
        footer={
          <>
            <Stack direction="row" p={1.5}>
              <JobCountCard
                icon={<WsIconPersons />}
                text="Teams"
                count={0}
                optionalTextColor={WsTypoColors.BLACK}
              />
              <JobCountCard
                icon={<WsIconSuggestions />}
                text="Users"
                count={0}
                optionalTextColor={WsTypoColors.BLACK}
              />
              <JobCountCard
                icon={<WsIconMapping />}
                text="Phones"
                count={0}
                optionalTextColor={WsTypoColors.BLACK}
              />
              <JobCountCard
                icon={<WsIconSubmitted />}
                text="Credit"
                count={0}
                optionalTextColor={WsTypoColors.BLACK}
              />
            </Stack>
            <Stack
              direction="row"
              p={2}
              spacing={2}
              width="100%"
              justifyContent="flex-end"
              alignItems="center"
            >
              <Grid container item xs={1}>
                <WsButton size="medium" onClick={() => navigate(`/workspace/${workspaceId}/edit`)}>
                  Edit
                </WsButton>
              </Grid>
            </Stack>
          </>
        }
        isCheckBox={false}
      />
    </Grid>
  );
};

export default WorkspaceDetailsCard;
